import React, {Component} from 'react'
import {compose, graphql, Query} from 'react-apollo'
import DocumentTitle from 'react-document-title'
import assign from 'lodash/assign'
import get from 'lodash/get'

import {Loader} from '../containers/Loader'
import {BOARDS_PER_PAGE} from '../config'
import ORG_QUERY from '../graphql/OrgQuery.graphql'
import Users from './Users'
import {getPageTitle, getUser} from '../utils'
import cn from 'classnames'
import EmptyState from './EmptyState'
import CreateBoard from './Board/CreateBoard'
import TimeAgo from './common/TimeAgo'
import Avatar from './common/Avatar'
import { DEFAULT_GROWTH_PLAN_ID, DEFAULT_GROWTH_PLAN_COST } from '../constants'
// import { DEFAULT_GROWTH_PLAN_ID } from '../constants'
// import chargebee from 'chargebee'

import axios from 'axios'
import PLAN_CHANGE_MUTATION from '../graphql/mutations/PlanChangeMutation.graphql'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.timeout = 300;

const urlEncode = function(data) {
    var str = [];
    for (var p in data) {
        if (data.hasOwnProperty(p) && (!(data[p] == undefined || data[p] == null))) {
            str.push(encodeURIComponent(p) + "=" + (data[p] ? encodeURIComponent(data[p]) : ""));
        }
    }
    return str.join("&");
}


class OrgSettings extends Component {

    // state = {
    //     active: true,
    //     alertVisible: false,
    //     // cbInstance: Chargebee.init({
    //     //     site: "jellyfish-chat"
    //     // })
    // }

    constructor(props) {
        super(props);

        this.state = {
            active: true,
            alertVisible: false,
            // cbInstance: chargebee.configure("test_X4KcdmeiLocu6zsDe0vZwP7qMKVPqNtjUR","jellyfish-chat-test"),
            // cbInstance: window.Chargebee.init({site: "jellyfish-chat-test" }),
            // cbInstance: window.Chargebee.init({site: "%REACT_APP_CHARGEBEE_SITE%" }),
            cbInstance: window.Chargebee.init({site: window.REACT_APP_CHARGEBEE_SITE, enableGATracking: true}),

            // planId: "unknown"
        };

        this.state.cbInstance.setPortalSession(() => {
            // we have used axios for performing http requests
            // Hit your end point that returns portal session object as response
            // This sample end point will call the below api
            // https://apidocs.chargebee.com/docs/api/portal_sessions#create_a_portal_session
            // return axios.post("/slack/chargebee/chargebee_portal_link/", urlEncode({})).then((response) => response.data);
            return axios.post("/slack/chargebee/chargebee_portal_link/", {}).then((response) => response.data).catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error);
                } else {
                    console.log('Error', error);
                }
            });
        });

        this.handleCheckout = this.handleCheckout.bind(this);
        this.handlePortal = this.handlePortal.bind(this);
        this.successHandler = this.successHandler.bind(this);
    };

    successHandler() {
        // this.state.planId = planId
        // this.setState({
        //     planId: planId
        // })
    //    TODO call the set plan method
    //     this.handlePlanChange();
        // console.log("successHandler this.state.orgRefetch", this.state.orgRefetch);
        console.log("successHandler this.handlePlanChange");
        // this.state.orgRefetch();
        this.handlePlanChange();
        console.log("successHandler finish");
    }


    handleCheckout(planId) {
        var that = this
        this.state.cbInstance.openCheckout({
            hostedPage() {
                console.log("checkout hostedPage");
                 return axios.post("/slack/chargebee/chargebee_checkout_new_url/", urlEncode({plan_id: planId})).then((response) => response.data)
            },
            success(hostedPageId) {
                console.log("checkout success", hostedPageId);
                // that.setState({
                //     planId: planId
                // })
                // that.successHandler(planId);
                that.successHandler();
            },
            loaded() {
                console.log("checkout loaded");
            },
            close() {
                console.log("checkout close");
            },
            error(error) {
                console.log("checkout error", error);
            },
            step(step) {
                console.log("checkout step", step);
            }
        })
    }

    handlePortal() {
        // this.state.cbInstance.createChargebeePortal().open({
        //     visit(visit) {
        //         console.log("portal visit", visit);
        //     }
        // });
        var that = this;
        this.state.cbInstance.createChargebeePortal().open({
            visit(visit) {
                console.log("portal visit", visit);
            },
            close() {
                console.log("portal close");
                that.successHandler();
            },
            subscriptionChanged(data) {
                // Matt Notes: for some reason this doesnt work.
                // Optional
                // called whenever a subscription is changed
                // data.subscription.id will give you the subscription id
                // Make sure you whitelist your domain in the checkout settings page
                console.log("subscriptionChanged");
            },
            // subscriptionChanged() {
            //     console.log("portal subscriptionChanged");
            //     that.successHandler();
            // },
            // close() {
            //     console.log("portal close", close);
            //     that.successHandler();
            // },
            // subscriptionChanged(data) {
            //     console.log("portal subscriptionChanged:", data);
            //     that.successHandler();
            // }
        });

        // var cbPortal = this.state.cbInstance.createChargebeePortal();
        // cbPortal.open({
        //     loaded: function() {
        //         // Optional
        //         // called when chargebee portal is loaded
        //         console.log("loaded");
        //     },
        //     close: function() {
        //         // Optional
        //         // called when chargebee portal is closed
        //         console.log("close");
        //     },
        //     visit: function(sectionName) {
        //         // Optional
        //         // called whenever the customer navigates across different sections in portal
        //         console.log("visit");
        //     },
        //     paymentSourceAdd: function() {
        //         // Optional
        //         // called whenever a new payment source is added in portal
        //         console.log("paymentSourceAdd");
        //     },
        //     paymentSourceUpdate: function() {
        //         // Optional
        //         // called whenever a payment source is updated in portal
        //         console.log("paymentSourceUpdate");
        //     },
        //     paymentSourceRemove: function() {
        //         // Optional
        //         // called whenever a payment source is removed in portal.
        //         console.log("paymentSourceRemove");
        //     },
        //     subscriptionChanged: function(data) {
        //         // Optional
        //         // called whenever a subscription is changed
        //         // data.subscription.id will give you the subscription id
        //         // Make sure you whitelist your domain in the checkout settings page
        //         console.log("subscriptionChanged");
        //     },
        //     subscriptionCustomFieldsChanged: function(data) {
        //         // Optional
        //         // called whenever a subscription custom fields are changed
        //         // data.subscription.id will give you the subscription id
        //         // Make sure you whitelist your domain in the checkout settings page
        //         console.log("subscriptionCustomFieldsChanged");
        //     },
        //     subscriptionCancelled: function(data) {
        //         // Optional
        //         // called when a subscription is cancelled
        //         // data.subscription.id will give you the subscription id
        //         // Make sure you whitelist your domain in the checkout settings page
        //         console.log("subscriptionCancelled");
        //     }
        // })
    }

    handleChangeActive = (e, active) => {
        e.preventDefault()
        this.setState({active})
    }

    handleAlertDismiss() {
        // console.log('test');
        // this.setState({ alertVisible: false });
    }

    handlePlanChange = async () => {
        const result = await this.props.planChange({
            // variables: {
            //     uuid: uuid,
            // },
        })
        if (get(result, 'data.planChange.success')) {
            let organization = get(result, 'data.planChange.organization')
            this.setState({
                organization: organization,
            })
        } else {
            // console.log('Failed to sync payment data. Please refresh the page and try again or contact support.')
        }
    }


    render() {
        const {active} = this.state
        return (
            <DocumentTitle title={getPageTitle('UserSettings')}>
                <Query
                    query={ORG_QUERY}
                    // variables={{
                    //     first: BOARDS_PER_PAGE,
                    //     isArchived: active,
                    // }}
                >
                    {({loading, error, data, fetchMore, refetch}) => {

                        if (loading) {
                            return <Loader />
                        }

                        // if (error) this.state.alertVisible = true;
                        let org = get(data, 'getOrganization', {});
                        this.state.organization = org;
                        var extraData = get(data, 'getOrganization.extraData', "");
                        var settings = get(data, 'getOrganization.settings', "")

                        // this.state.planId = org.planId;
                        this.state.orgRefetch = refetch;

                        // var isFree = !org.billingPlanId || org.billingPlanId.startsWith('free');
                        //var isGrowth = org.billingPlanId && org.billingPlanId.startsWith('grow');
                        var isGrowth = this.state.organization.billingPlanId && this.state.organization.billingPlanId.includes('jelly-growth');

                        var isEnterprise = this.state.organization.billingPlanId && this.state.organization.billingPlanId.includes('jelly-enterprise');
                        var isFree = !isGrowth && !isEnterprise;

                        this.state.isFree = isFree
                        this.state.isGrowth = isGrowth
                        this.state.isEnterprise = isEnterprise

                        //testing
                        // Free
                        // var isFree = true
                        // var isGrowth = false
                        // var isEnterprise = false
                        // Growth
                        // var isFree = false
                        // var isGrowth = true
                        // var isEnterprise = false
                        // Enterprise
                        // var isFree = false
                        // var isGrowth = false
                        // var isEnterprise = true

                        // console.log('isFree:', isFree);
                        // console.log('isGrowth:', isGrowth);
                        // console.log('isEnterprise:', isEnterprise);
                        // console.log('isEnterprise:', isEnterprise);
                        // console.log('this.state.organization:', this.state.organization);

                        //
                        var upgradePaymentPlanId = DEFAULT_GROWTH_PLAN_ID;
                        // var upgradePaymentPlanCost = '$'+ DEFAULT_GROWTH_PLAN_COST + "  month";
                        var enableEnterpriseUpgradeOption = false;

                        if (settings) {
                            var settingsObj = JSON.parse(settings)
                            // console.log('settings:', settings);
                            // console.log('settings:', unescape(settings));
                            // console.log('settings:', settingsObj);
                            var settingsUpgradePaymentPlanId = settingsObj.upgrade_payment_plan_id;
                            if (settingsUpgradePaymentPlanId) {
                                upgradePaymentPlanId = settingsUpgradePaymentPlanId;
                                enableEnterpriseUpgradeOption = settingsUpgradePaymentPlanId.includes('jelly-enterprise');
                                // upgradePaymentPlanCost = "";
                            }
                        }
                        // var enableGrowthUpgradeOption = !enableEnterpriseUpgradeOption;

                        console.log("upgradePaymentPlanId:" + upgradePaymentPlanId);
                        // console.log("upgradePaymentPlanCost:" + upgradePaymentPlanCost);

                        var iconUrl = ""
                        if (extraData) {
                            var extraDataObj = JSON.parse(extraData)
                            // console.log('extraData:', extraData);
                            // console.log('extraData:', unescape(extraData));
                            // console.log('extraData:', extraDataObj);
                            // console.log('extraDataObj.icon.image_44:', extraDataObj.icon.image_44);
                            // console.log('extraDataObj.icon.image_132:', extraDataObj.icon.image_132);
                            iconUrl = extraDataObj.icon.image_132;
                        }
                        // console.log('exclude_downvote:', settings["exclude_downvote"]);
                        // this.state.organization = org;

                        return (
                            <div>

                            <div className="navbar bg-white border-bottom">
                                <div className="btn-group" role="group" aria-label="Button group">
                                    <span className="text-muted">Settings</span>
                                    <span className="text-muted px-2">/</span>
                                    <span><a className="" href="/org-settings">Organization</a></span>
                                    <span><a className="px-3" href="/user-settings">Users</a></span>
                                </div>
                            </div>

                            <div className="container">

                                <div className="row">

                                {error ? (
                                    <div className="mt-3">
                                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                            <strong>Sad Jellyfish 😫.</strong> We're are sorry, there was an error: ${error.message}, please try again.
                                            {/*<button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this.handleAlertDismiss.bind(this)}>*/}
                                                {/*<span aria∂-hidden="true">&times;</span>*/}
                                            {/*</button>*/}
                                        </div>
                                    </div>
                                ) : null}

                                {loading ? null :

                                    <div className="w-100 mt-4">

                                        <div className="card">
                                            <div className="card-header pricing-card-header">
                                                {/*<i className="fa fa-align-justify"></i>*/}
                                                <span><strong>Organization</strong></span>
                                                {/*<span className="text-muted float-right"><i className="fa fa-info-circle"/> Some Text</span>*/}
                                            </div>
                                            <div className="card-body">
                                                    <div className="row mb-2">
                                                        {/*<th>{org.teamName}</th>*/}
                                                        <div className="col"><strong>{this.state.organization.teamName}</strong></div>
                                                        <div className="col"><strong>Workspace</strong></div>
                                                        <div className="col"><strong>Plan</strong></div>
                                                        <div className="col d-sm-down-none"><strong>Installed</strong></div>
                                                        {/*<th>Status</th>*/}
                                                    </div>
                                                    <div className="row">
                                                        <div className="col"><Avatar width={66} src={iconUrl} /></div>
                                                        {/*<td>{org.teamDomain}</td>*/}
                                                        <div className="col"><a target="_blank" href={"https://"+this.state.organization.teamDomain+".slack.com"}> {this.state.organization.teamDomain}.slack.com</a></div>
                                                        {/*<td><TimeAgo date={org.created} className="text-muted"/></td>*/}
                                                        <div className="col">
                                                            {/*<span className="badge badge-success">{this.state.planId}</span>*/}
                                                            {/*    <span className="badge badge-light">*/}
                                                                    <strong>
                                                                    {/*{org.plan}*/}
                                                                    {this.state.isFree ? "Free" : ""}
                                                                    {this.state.isGrowth ? "Growth" : ""}
                                                                    {this.state.isEnterprise ? "Enterprise" : ""}
                                                                    </strong>
                                                                {/*</span>*/}
                                                            {/*<input type="checkbox" aria-label="" checked={user.isOrganizationAdmin?'true':'false'}/>*/}
                                                        </div>
                                                        <div className="col d-sm-down-none"><TimeAgo date={this.state.organization.created} className="text-muted"/></div>
                                                    </div>
                                            </div>
                                        </div>

                                        {/* Plan selector */}

                                        {/*{this.state.organization.billingEnabled &&*/}

                                            <div className="card">
                                                <div className="card-header pricing-card-header">
                                                    {/*<i className="fa fa-align-justify"></i>*/}
                                                    <span><strong>Payment Plans</strong></span>
                                                    {/*<span className="text-muted float-right"><i className="fa fa-info-circle"/> Some Text</span>*/}
                                                </div>
                                                <div className="card-body">
                                                    <div className="container">
                                                        <div className="row"><strong>You are currently using our <u>
                                                            {this.state.isFree ? "free" : ""}
                                                            {this.state.isGrowth ? "growth" : ""}
                                                            {this.state.isEnterprise ? "enterprise" : ""}
                                                        </u> plan.</strong></div>
                                                        {this.state.isFree && (
                                                            <div className="row text-muted py-2">
                                                                Ready to upgrade? - Choose from one of our beautiful plans below.
                                                            </div>
                                                        )}
                                                        {this.state.isGrowth && (
                                                            <div className="row text-muted py-2">
                                                                Ready to explore our enterprise options? &nbsp;
                                                                <a target="_blank" href="https://drift.me/jellyfish"
                                                                   className="">Let's Chat!</a>
                                                            </div>
                                                        )}
                                                        {this.state.isEnterprise && (
                                                            <div className="row text-muted py-2">
                                                                Contact hello@jellyfish.chat to make changes.
                                                            </div>
                                                        )}
                                                        {/* Manage Account Link */}
                                                        {/*{(this.state.isGrowth || this.state.isEnterprise) && (*/}
                                                        {this.state.isGrowth && (
                                                            <div className="row mt-1">
                                                                <a href='#' onClick={this.handlePortal}>Manage account</a>
                                                            </div>
                                                        )}

                                                        {/*<div className="row"><a href='#' onClick={this.handlePortal}>Manage account</a></div>*/}
                                                        {/*<div className="row text-muted">&nbsp;</div>*/}
                                                        <div className="row">&nbsp;</div>

                                                        {/* 3 Pricing Cards below */}

                                                        <div className="row align-items-center">

                                                            {settingsObj.upgrade_payment_plan_id ? null :
                                                                <div className="col-md-4 "
                                                                    // style="visibility: visible; animation-name: tafFadeInRight;"
                                                                >
                                                                    {/*<div className="card pricing">*/}
                                                                    <div className="card pricing text-center">
                                                                        <div
                                                                            className="card-header pricing-card-header">
                                                                            <h3>Startup</h3>
                                                                            <h6>Free</h6>
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="pb-2">
                                                                                <div>Unlimited Sessions</div>
                                                                                <div>Unlimited Questions</div>
                                                                                {/*<div>Up to 100 Users</div>*/}
                                                                                {/*<div>Free</div>*/}
                                                                            </div>
                                                                            <div className="">
                                                                                {/*<a href="#" className="btn btn-outline-primary  mt-40">Downgrade</a>*/}
                                                                                {this.state.isFree && (
                                                                                    <span
                                                                                        className="jelly-color-primary"><i
                                                                                        className="fas fa-lg fa-check"></i></span>
                                                                                )}
                                                                                {/*{isGrowth && (*/}
                                                                                {/*<a href="#" className="btn btn-link mt-40"  onClick={() => this.handleCheckout("cbdemo_free")} >Downgrade</a>*/}
                                                                                {/*)}*/}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }

                                                            {settingsObj.upgrade_payment_plan_id ? null :
                                                                <div className="col-md-4 ">
                                                                    <div className="card pricing center text-center">
                                                                        <div className="card-header pricing-card-header">
                                                                            <h3>Growth</h3>
                                                                            {/*<span><u>Most Popular</u></span>*/}
                                                                            {this.state.isFree && (<h6>${DEFAULT_GROWTH_PLAN_COST} / month</h6>)}
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="pb-2">
                                                                                <div>All Startup Features +</div>
                                                                                {/*<div>Up to 300 Users</div>*/}
                                                                                <div>Q&A Moderation</div>
                                                                                <div>Pdf Export</div>
                                                                                {/*<div>Free during Beta</div>*/}

                                                                                {/*<div>Configurable Sessions</div>*/}
                                                                                {/*<div>30 day Free Trial</div>*/}
                                                                                {/*{this.state.isFree && (<div>{upgradePaymentPlanCost}</div>)}*/}
                                                                            </div>
                                                                            <div className="">
                                                                                {/*<a href="#" className="btn btn-primary mt-40"  onClick={this.handleCheckout} >Select Plan</a>*/}
                                                                                {this.state.isFree && !this.state.organization.billingEnabled && (
                                                                                    <button disabled="true" className="btn btn-primary mt-40 disabled" onClick={false} >Coming Soon...</button>
                                                                                )}
                                                                                {this.state.isFree && this.state.organization.billingEnabled && (
                                                                                    <button className="btn btn-primary mt-40" onClick={() => this.handleCheckout(upgradePaymentPlanId)}>Upgrade</button>
                                                                                )}
                                                                                {this.state.isGrowth && (
                                                                                    <span className="jelly-color-primary"><i
                                                                                        className="fas fa-2x fa-check"></i></span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }


                                                            <div className="col-md-4"
                                                                // style="visibility: visible; animation-name: tafFadeInLeft;"
                                                            >
                                                                <div className="card pricing text-center">
                                                                    <div className="card-header pricing-card-header">
                                                                        <h3>Enterprise</h3>
                                                                        <h6>Free Trial</h6>
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <div className="pb-2">
                                                                            <div>All Growth Features +</div>
                                                                            {/*<div>Unlimited Users</div>*/}
                                                                            <div>User Roles</div>
                                                                            <div>Configurable Sessions</div>
                                                                            <div>Premium Support</div>
                                                                            {/*<div>Free Trial</div>*/}
                                                                        </div>
                                                                        <div className="">
                                                                            {/*<a target="_blank" href="https://drift.me/jellyfish" className="btn btn-outline-primary mt-40">Contact Us</a>*/}
                                                                            {this.state.isEnterprise && (
                                                                                <span className="jelly-color-primary"><i
                                                                                    className="fas fa-lg fa-check"></i></span>
                                                                            )}
                                                                            {!this.state.isEnterprise && enableEnterpriseUpgradeOption && (
                                                                                <a href="#" className="btn btn-primary mt-40 " onClick={() => this.handleCheckout(upgradePaymentPlanId)}>Upgrade</a>
                                                                            )}
                                                                            {!this.state.isEnterprise && !enableEnterpriseUpgradeOption && (
                                                                                <a target="_blank" href="https://meetings.hubspot.com/matt772" className="btn btn-primary mt-40">Let's Chat</a>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                            {/*//    end of if billing*/}
                                        {/*}*/}

                                    </div>
                                }
                            </div>
                                <div className="row"></div>
                            </div>
                            </div>
                        )
                    }}
                </Query>
            </DocumentTitle>

        )
    }
}

// export default OrgSettings

export default compose(
    graphql(PLAN_CHANGE_MUTATION, {
        name: 'planChange',
    })
)(OrgSettings)




// WEBPACK FOOTER //
// ./src/components/OrgSettings.jsx